import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import footerlogo from "../../assets/Images/footer-logo.png";

const Footer = () => {
  return (
    <footer className="simple-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={footerlogo} alt="Logo" />
        </div>

        <div className="footer-links">
          <Link to="/RefundPolicy">Refund Policy</Link>
          <span>|</span>
          <Link to="/TermsOfService">Terms Of Service</Link>
          <span>|</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span>|</span>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-social">
          <a href="https://www.instagram.com/iindvo/" target="_blank" rel="noopener noreferrer">Instagram</a>
          <span>|</span>
          <a href="http://linkedin.com/company/indvo" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <span>|</span>
          <a href="https://www.facebook.com/iIndvo" target="_blank" rel="noopener noreferrer">Facebook</a>
          <span>|</span>
          <a href="https://www.youtube.com/@iINDVO" target="_blank" rel="noopener noreferrer">YouTube</a>
          <span>|</span>
          <a href="https://wa.me/919407861249?text=Hello%20Indvo" target="_blank" rel="noopener noreferrer">WhatsApp</a>
        </div>

        <div className="footer-bottom">
          <p>© 2025 Global Expansion Gateway</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
